import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { createOranConfigRecords } from '@api/schemaConfig';

import { ICreateSchemaDTO } from '@interfaces/cmModule/dto/schemaConfigDTO';
import { IOnClose } from '@interfaces/common/handlers';

import {
	CREATE_YANG_FILES,
	MAVENIR_SCHEMA_CONFIG,
	ORAN_VALUES_FOR_CREATE_SCHEMA,
} from '@constants/queryKeys';

interface ICreateMavenirConfigReturnType {
	createOranYangFiles: UseMutateFunction<any, any, ICreateSchemaDTO[], any>;
	isLoadingCreateOranYangFiles: boolean;
}

export const useCreateOranYangFiles = ({
	onClose,
}: IOnClose): ICreateMavenirConfigReturnType => {
	const queryClient = useQueryClient();

	const {
		mutate: createOranYangFiles,
		isLoading: isLoadingCreateOranYangFiles,
	} = useMutation<ICreateSchemaDTO[]>({
		mutationKey: [CREATE_YANG_FILES],
		mutationFn: createOranConfigRecords,
		onSuccess: () => {
			onClose();

			return [
				queryClient.invalidateQueries([ORAN_VALUES_FOR_CREATE_SCHEMA]),
				queryClient.invalidateQueries([MAVENIR_SCHEMA_CONFIG]),
			];
		},
	});

	return {
		createOranYangFiles,
		isLoadingCreateOranYangFiles,
	};
};
